"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactColor = require("react-color");
var _theme = require("../utils/theme");
var _helpers = require("@qwkin/helpers");
var _ColorPicker = require("./ColorPicker.styles");
var _styledComponents = require("styled-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ColorPicker = function ColorPicker(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$onInit = _ref.onInit,
    onInit = _ref$onInit === void 0 ? _helpers.identity : _ref$onInit,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _helpers.identity : _ref$onChange,
    initialColor = _ref.initialColor,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 30 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 30 : _ref$height,
    children = _ref.children;
  var colors = ['#00B0FF', '#2196F3', '#1976D2', '#FFEB3B', '#FFC107', '#FF9800', '#E040FB', '#9C27B0', '#673AB7', '#F56898', '#E91E63', '#BE1C5C', '#C1D21D', '#8BC34A', '#2D7731', '#009688', '#FF5252', '#D32F2F', '#9E9E9E', '#535252', '#607D8B'];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    displayColorPicker = _useState2[0],
    setDisplayColorPicker = _useState2[1];
  var _useState3 = (0, _react.useState)(initialColor !== null && initialColor !== void 0 ? initialColor : colors[Math.floor(Math.random() * colors.length)]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    color = _useState4[0],
    setColor = _useState4[1];
  var onColorChange = function onColorChange(color) {
    setColor(color.hex);
    onChange(color.hex);
  };
  var onClick = function onClick() {
    return setDisplayColorPicker(!displayColorPicker);
  };
  var onPickerClose = function onPickerClose() {
    return setDisplayColorPicker(false);
  };
  (0, _react.useEffect)(function () {
    onInit(color);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.Swatch, {
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.Color, {
    width: width,
    height: height,
    color: color
  })), displayColorPicker && /*#__PURE__*/_react["default"].createElement(_ColorPicker.Popover, null, /*#__PURE__*/_react["default"].createElement(_ColorPicker.Cover, {
    onClick: onPickerClose
  }), /*#__PURE__*/_react["default"].createElement(_reactColor.GithubPicker, {
    colors: colors,
    color: color,
    onChange: onColorChange
  })));
};
var _default = exports["default"] = ColorPicker;